export const HomeObjOne = {
    topLine: 'Hey! There',
    headingText: `I'm`,
    RootName: `Haris Khan`,
    desc: 'Front End Developer',
    AnimateImg: 'images/animation_500_kkk690jn.gif'
}

export const AboutObj = {
    ImgSrc: 'images/haris22.jpg',
    headline: 'Haris Khan',
    paragraph: 'I started coding in the 2019 and I am self-taught developer. I have serious passion for modern looking websites with a little bit of animations. I love what I am doing and I am highly motivated to collaborate with someone. If you are up into some projects, just let me know!',
    FbLink: 'https://facebook.com/thehariskhan/',
    instaLink: 'https://www.instagram.com/thehariskhan05/',
    TwitLink: 'https://twitter.com/thehariskhan05',
    LinkdLink: 'https://www.linkedin.com/in/thehariskhan05/',
    GitHubLink: 'https://t.co/TErHIXNBSZ?amp=1'
}

export const ProjObjMain = {
    headline:'ChatRoom',
    description:'Online ChatAPP created using Reactjs and Firebase. You can create Your room in it and start chatting with friends.',
    buttonLabel:'Demo',
    DemoLink: 'https://chatroom-9c550.web.app/',
    GithubLink: 'https://github.com/theHarisKhan/ChatRoom',
    img:'images/ChatRoomApp_thehariskhan_FrontEndDeveloper.png',
    alt:'ChatRoom App',
}

export const ProjObjOne = {
    headline:'Quiz App',
    description:'Take a Quiz to check your computer knowledge.',
    buttonLabel:'Demo',
    DemoLink: 'https://take-a-quiz.netlify.app',
    GithubLink: 'https://github.com/theHarisKhan/QuizApp',
    img:'images/takeaquiz_thehariskhan_FrontEndDeveloper.png',
    alt:'Quiz App',
}

export const ProjObjTwo = {
    headline:'Book Review App',
    description:'Do not Judge a book by cover so search about it on book review App and get all useful information related to the book in a click.',
    buttonLabel:'Demo',
    DemoLink: 'https://booksreview.netlify.app/',
    GithubLink: 'https://github.com/theHarisKhan/BookReviewApp',
    img:'images/bookreview_thehariskhan_FrontEndDeveloper.png',
    alt:'Book Review App',
}

export const ProjObjThree = {
    headline:'Expense Manager',
    description:'Track your expenses & income flow and help yourself to save your cash from burning in ash.',
    buttonLabel:'Demo',
    DemoLink: 'https://expensetracker-thk.netlify.app/',
    GithubLink: 'https://github.com/theHarisKhan/ExpenseTracker',
    img:'images/expenseManager_thehariskhan_FrontEndDeveloper.png',
    alt:'Expense Manager App',
}

export const ProjObjFour = {
    headline:'TodoApp',
    description:'TodoList App to make a list of Your todo works, Help to manage your tasks to perform them in manged timeframe and enjoy the day.',
    buttonLabel:'Demo',
    DemoLink: 'https://codepen.io/haris-khan05/pen/ZEWopez',
    GithubLink: 'https://github.com/theHarisKhan/todo',
    img:'images/TodoList_thehariskhan_FrontEndDeveloper.png',
    alt:'TodoList App',
}

export const ProjObjFive = {
    headline:'MsgLike 007',
    description:'Ceaser Cipher App to Encrypt & Decrypt your messages. So you can Communicate Like an 007 Agent. without fear of Caught up.',
    buttonLabel:'Demo',
    DemoLink: 'https://msglike007.netlify.app/',
    GithubLink: 'https://github.com/theHarisKhan/Secret-Message',
    img:'images/SecretMessage_thehariskhan_FrontEndDeveloper.png',
    alt:'Secret Message App',
}

export const ProjObjSix = {
    headline:'Amazon Clone',
    description:'Amazon Clone build using ReactJs, Firebase and Stripe for Payment Process.',
    buttonLabel:'Demo',
    DemoLink: 'https://clone-37ef5.web.app/',
    GithubLink: 'https://github.com/theHarisKhan/Amazon-Clone',
    img:'images/AmazonClone_thehariskhan_FrontEndDeveloper.png',
    alt:'Amazon Clone',
}

export const ServicesObj = {
    Img1: 'images/Load more-bro.png',
    head1: 'DESIGN WHAT YOU WANT.',
    desc1: 'I love designing websites and keep things as simple as possible. My goals is to focus on minimalism and conveying the message that you want to send.',
    Img2: 'images/Web devices-rafiki.png',
    head2: 'DEVELOP WHAT YOU NEED.',
    desc2: ` I'm a developer, so I know how to create your website to run across devices using the latest technologies available.`,
    Img3: 'images/Browser stats-cuate.png',
    head3: 'HELP YOU TO GROW.',
    desc3: `I can create beautiful websites for your business that will definitely increase traffic to your site.`
}

export const FooterObj = {
    FbLink: 'https://facebook.com/thehariskhan/',
    instaLink: 'https://www.instagram.com/thehariskhan05/',
    TwitLink: 'https://twitter.com/thehariskhan05',
    LinkdLink: 'https://www.linkedin.com/in/thehariskhan05/',
    GitHubLink: 'https://t.co/TErHIXNBSZ?amp=1'
}